// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"48d2ed75","50":"3665a3a9","58":"b1a07cd1","149":"927c040a","377":"6f0545d2","637":"c860bc81","957":"b8d98deb"}[chunkId] + ".chunk.js";
};